import {Component} from '@angular/core';
import {UsuarioServices} from '../services/usuario.services';
import {Router} from '@angular/router';
import {UUIDLOCALSTORAGE} from '../../../config';


@Component({
  selector:"login",
  templateUrl:"../templates/login.template.html"
})
export class LoginComponent {
  public user:any ={
    username:"",
    password:""
  }

  constructor(private us:UsuarioServices, private router:Router){

  }

  iniciarSesion(){

    this.us.loguearUsuario(this.user).subscribe(r=>{

      if(r.codigo == 0){

        let dataToken = this.us.decodeToken(r.token);


        localStorage.setItem(UUIDLOCALSTORAGE, r.token);
        // localStorage.setItem("user", JSON.stringify(dataToken));
        this.router.navigate(["/"]).then();
      }
      else{
        alert("Usuario o contraseña incorrecta");
      }
    });


  }
}
